import '../../utils/index.mjs';
import _sfc_main from './src/backtop2.mjs';
export { backtopEmits, backtopProps } from './src/backtop.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBacktop = withInstall(_sfc_main);

export { ElBacktop, ElBacktop as default };
//# sourceMappingURL=index.mjs.map
